import { createShortUrlEndpoint } from 'root/src/server/modules/shortUrl/endpoints/createShortUrl.endpoint';
import { getShortUrlStatsEndpoint } from 'root/src/server/modules/shortUrl/endpoints/getShortUrlStats.endpoint';
export const shortUrlEndpoints = Object.assign(Object.assign({}, createShortUrlEndpoint), getShortUrlStatsEndpoint);
